<!-- ABOUT_FEATURES -->
<div class="white_card about_card">
  <h5>features</h5>
  <ul>
    <li>no auto routing</li>
    <li>no human readable unit format</li>
    <li>no price fecthing, 1 NEAR = 1 NEAR</li>
    <li>no rules</li>
    <li>no error handinling, verify tx reults on near blocks</li>
    <li>no whitelist, no blacklist</li>
    <!-- <li>create custom trade routes</li> -->
    <!-- <li>small fee on every trade, that goes back to community or gets burned</li> -->
  </ul>
</div>

<!--  -->
<!-- =========================================== -->
<style>
  .about_card ul {
    text-align: left;
  }
</style>
